<script setup>
import { storeToRefs } from 'pinia'
import { onMounted, onUnmounted } from 'vue'

import { useRoute } from 'vue-router/dist/vue-router'
import { useProjectUserStore } from '@/stores/project_user'
import { useProjectStore } from '@/stores/project'
import _ from 'lodash'
import { useAuthorizationStore } from '@/stores/authorization'
import ProjectSideBar from '@/components/project-detail/ProjectSideBar.vue'
import { AppBackground, ProjectHeaderImage } from '@haskoning/vue-component-library'
import { useSpeckleStore, useSpeckleAuthStore } from '@haskoning/vue-speckle'
import { useProjectSpeckleStore } from '@/stores/projectSpeckle'

const route = useRoute()

const projectStore = useProjectStore()
const projectUserStore = useProjectUserStore()
const authorizationStore = useAuthorizationStore()
const speckleStore = useSpeckleStore({ autoSelectData: false })
const projectSpeckleStore = useProjectSpeckleStore()
const speckleAuthStore = useSpeckleAuthStore()

const { items: authorizations } = storeToRefs(authorizationStore)
const { currentItem: currentProject } = storeToRefs(useProjectStore())
const { currentItem: currentProjectUser } = storeToRefs(projectUserStore)

onMounted(async () => {
  await projectUserStore.fetchItems({ project: route.params.id })
  projectUserStore.setCurrentItem()
  if (authorizations.value.length === 0) {
    await authorizationStore.fetchItems()
  }
  authorizationStore.setCurrentRole([currentProjectUser.value.role])
  if (!currentProject.value || _.isEmpty(currentProject.value)) {
    await projectStore.fetchItem(route.params.id)
  }
  if (speckleAuthStore.isAuthenticated && (await speckleAuthStore.checkTokenValidity())) {
    await speckleStore.getAllUserProjects()
    await projectSpeckleStore.fetchProjectSpeckle(route.params.id)
    await speckleStore.getSpeckleModels()
  }
})

onUnmounted(() => {
  projectSpeckleStore.resetRelatedSpeckleData()
})
</script>
<template>
  <div style="display: flex; flex-direction: column" class="fill-height">
    <ProjectHeaderImage :lazy-src="'/header_lazy.jpg'" :src="'/header.jpeg'" />
    <AppBackground>
      <ProjectSideBar />
      <router-view></router-view>
    </AppBackground>
  </div>
</template>
